import { Component, Input, OnInit, HostListener } from '@angular/core';
import { NgbActiveModal, NgbCalendar, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import dayjs from 'dayjs';

@Component({
  selector: 'app-range-date-picker',
  templateUrl: './range-date-picker.component.html',
  styleUrls: ['./range-date-picker.component.scss'],
  standalone: false
})
export class RangeDatePickerComponent implements OnInit {

  @Input() initialFromDate: string | null = null;
  @Input() initialToDate: string | null = null;

  fromDate: NgbDate | null = null;
  toDate: NgbDate | null = null;
  hoveredDate: NgbDate | null = null;
  displayMonths: number = 2;

  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly calendar: NgbCalendar,
    public readonly formatter: NgbDateParserFormatter
  ) { }

  ngOnInit(): void {
    this.updateDisplayMonths(window.innerWidth);
    if (this.initialFromDate) {
      const d = dayjs(this.initialFromDate);
      this.fromDate = new NgbDate(d.year(), d.month() + 1, d.date());
    }
    if (this.initialToDate) {
      const d = dayjs(this.initialToDate);
      this.toDate = new NgbDate(d.year(), d.month() + 1, d.date());
    }

    if (!this.fromDate) {
      this.fromDate = this.calendar.getToday();
      this.toDate = this.calendar.getToday();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateDisplayMonths(event.target.innerWidth);
  }

  private updateDisplayMonths(width: number) {
    this.displayMonths = width < 768 ? 1 : 2;
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate || (this.fromDate && this.toDate)) {
      this.fromDate = date;
      this.toDate = null;
    } else {
      const d1 = dayjs(`${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`);
      const d2 = dayjs(`${date.year}-${date.month}-${date.day}`);
      if (d2.isAfter(d1) || d2.isSame(d1, 'day')) {
        this.toDate = date;
      } else {
        this.fromDate = date;
        this.toDate = null;
      }
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  isFrom(date: NgbDate) {
    return date.equals(this.fromDate);
  }

  isTo(date: NgbDate) {
    return date.equals(this.toDate);
  }

  disableFuture = (date: any) => {
    return NgbDate.from(date)!.after(this.calendar.getToday());
  };

  getCalendarStartDate() {
    return this.fromDate ?? this.calendar.getToday();
  }

  apply() {
    if (this.fromDate && this.toDate) {
      const start = dayjs(`${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`).format('YYYY-MM-DD');
      const end = dayjs(`${this.toDate.year}-${this.toDate.month}-${this.toDate.day}`).format('YYYY-MM-DD');
      this.activeModal.close({ fromDate: start, toDate: end });
    }
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
